module.exports = __webpack_public_path__ + "img/cancelled.823e0ffa.svg";